import React from "react";
import AboutBackground from "../Assets/about-background.png";
import AboutBackgroundImage from "../Assets/about-background-image.png";
import { useNavigate } from 'react-router-dom'; 
import { FiArrowRight } from "react-icons/fi"; 
import { BsFillPlayCircleFill } from "react-icons/bs";

const About = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleNavigateToOver = () => {
    navigate('/over'); 
  };

  return (
    <div className="about-section-container">
      <div className="about-background-image-container">
        <img src={AboutBackground} alt="" />
      </div>
      <div className="about-section-image-container">
        <img src={AboutBackgroundImage} alt="" />
      </div>
      <div className="about-section-text-container">
        <p className="primary-subheading">Over</p>
        <h1 className="primary-heading">
          Wie zijn wij?
        </h1>
        <p className="primary-text">
          Wij van het Gebakken Aardappeltje hebben als doel een sterrenchef-ervaring toegankelijk te maken voor de gewone burger in Nederland.
        </p>
        <p className="primary-text">
          Onze topchefs delen hun geheime recepten, die jij aan de hand van onze instructies thuis kunt bereiden. En dit allemaal met normale ingrediënten die je in de supermarkt kunt vinden.
        </p>
        <div className="about-buttons-container">
          <button className='secondary-button' onClick={handleNavigateToOver}>
            Lees meer <FiArrowRight />{""}
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
